<template>
  <DeleteConfirm
      itemKey="Ticket"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tickets from '@/services/tickets'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Tickets
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť tiket "' + Item.title + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť tiket "' + Item.title + '"?'
      },
      deleteData() {
        return Tickets
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
